import React from 'react';
import PropTypes from 'prop-types';
import Post from '../../models/post';

import ImageView from './media/ImageView';
import LinkView from './media/LinkView';
import VideoView from './media/VideoView';
import CardView from './media/CardView';
import CouponCardView from './media/CouponCardView';

import ImageFeedView from './FeedView/ImageFeedView';
import CardFeedView from './FeedView/CardFeedView';
import VideoFeedView from './FeedView/VideoFeedView';
import LinkFeedView from './FeedView/LinkFeedView';
import PostTitleAndTextFeedView from './FeedView/PostTitleAndTextFeedView';

import ProfileImage from '../../components/ProfileImage';
import timeAgoInWords from '../../utils/timeAgoInWords';
import getImageUrl from '../../utils/getImageUrl';

const PostBox = ({ type, post, device }) => {
  const splited = post.permalink.split('/');
  const profilePath = `/${splited.slice(3, 4)}`;
  const postPath = `/${splited.slice(3, splited.length).join('/')}`;

  const isFeed = type && type === 'feed';

  const renderFeedView = () => {
    if (post.media.isEmpty()) {
      return ;
    }

    if (post.type === 'image') {
      return (
        <ImageFeedView images={post.media} postPath={postPath} />
      );
    } else if (post.type === 'card') {
      return (
        <CardFeedView cards={post.media} postPath={postPath} />
      );
    } else if (post.type === 'video') {
      return (
        <VideoFeedView video={post.media.first()} />
      );
    } else if (post.type === 'link') {
      return (
        <LinkFeedView link={post.media.first()} />
      );
    } else {
      return null;
    }
  };

  return (
    <div>
      <div className="post_profile">
        {
          post.pinned && <em className="post_pin"><span className="ico_plus">핀 포스트</span></em>
        }
        { post.author.profileImage ? (
          <div className="wrap_thumb">
            <a href={isFeed ? postPath : profilePath}>
              <ProfileImage image={post.author.profileImage} sizeType="small" />
          </a>
          </div>
        ) : (
          <div className="wrap_thumb">
          </div>
        )}
        <div className="wrap_info">
          <strong className="txt_name"><a href={isFeed ? postPath : profilePath} target="_self">{post.author.name}</a></strong>
          <span className="txt_time">
            <a href={postPath}>{timeAgoInWords(new Date(post.publishedAt))}</a>
          </span>
        </div>
              </div>

      {
        isFeed ? <PostTitleAndTextFeedView post={post} postPath={postPath} device={device} />
          : (
            <div className="post_txt">
              <strong className="tit_post">{ post.isBlind() ? "" : post.title }</strong>
              <p className="desc_post">{ post.text }</p>
            </div>
          )
      }
      {
        (!post.isBlind()) && (
          isFeed ? renderFeedView() : (
            <div className="post_card">
              {
                post.media.map((medium, idx) => {
                  if (!medium) {
                    console.error('MEDIUM NOT FOUND!!', post.id, idx);
                    return null;
                  }
                  if (medium.type === 'image') {
                    return (
                      <ImageView type={type} image={medium} key={idx} />
                    );
                  } else if (medium.type === 'video') {
                    return (
                      <VideoView type={type} video={medium} key={idx} />
                    );
                  } else if (medium.type === 'card' || medium.type === 'verticalCard') {
                    return (
                      <CardView type={type} card={medium} key={idx} device={device} />
                    );
                  } else if (medium.type === 'couponCard') {
                    return (
                      <CouponCardView type={type} couponCard={medium} key={idx} />
                    );
                  } else if (medium.type === 'link') {
                    return (
                      <LinkView type={type} link={medium} key={idx} />
                    );
                  }
                  return null;
                })
              }
            </div>
          ))
      }
    </div>
  )
};

PostBox.propTypes = {
  post: PropTypes.instanceOf(Post)
};

export default PostBox;



// WEBPACK FOOTER //
// ./src/components/PostBox/index.js